import axios from "axios";
import api from "./api";
import { ListParceiro, ParceiroResumo, ParceiroInsert } from "../types/Parceiros";

export async function findAllInstitutions(
  currentPage: number,
  perPage: number,
  searchNome ?: string,
  searchNomeResp ?: string,
  searchCnpj ?: string,
  searchEmail ?: string,
  searchStatus?: number,
): Promise<ListParceiro> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/all`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        page: currentPage,
        perPage,
        searchNome,
        searchNomeResp,
        searchCnpj,
        searchEmail,
        searchStatus,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar instituições:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar instituições"
    );
  }
}

export async function findInstitutionsResumo(): Promise<ParceiroResumo[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/all`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        listResumo: 1,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar instituições:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar instituições"
    );
  }
}

export async function inactivateInstitution(
  institutionId: string | number
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/inactivate/${institutionId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await api.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
  } catch (error) {
    throw new Error(`Erro ao inativar instituição: ${error}`);
  }
}

export async function activateInstitution(
  institutionId: string | number
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/activate/${institutionId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await axios.patch(
      apiUrl,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      },
    );
    
  } catch (error) {
    throw new Error(`Erro ao ativar instituição: ${error}`);
  }
}

export async function inactivateInstitutions(
  institutionsIds: number[]
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/inactivate-multiple`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await axios.post(
      apiUrl,
      {
        ids: institutionsIds
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      },
    );
    
  } catch (error) {
    throw new Error(`Erro ao inativar instituições: ${error}`);
  }
}

export async function activateInstitutions(
  institutionsIds: number[]
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/activate-multiple`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await axios.post(
      apiUrl,
      {
        ids: institutionsIds
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      },
    );
    
  } catch (error) {
    throw new Error(`Erro ao reativar instituições: ${error}`);
  }
}

export async function createInstitution(
  data: ParceiroInsert
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/institution`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await axios.post(
      apiUrl,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      },
    );
    
  } catch (error) {
    throw new Error(`Erro ao cadastrar a instituição: ${error}`);
  }
}

export async function updateInstitution(
  partnerId: string,
  data: ParceiroInsert
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/${partnerId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await axios.put(
      apiUrl,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      },
    );
    
  } catch (error) {
    throw new Error(`Erro ao atualizar a instituição: ${error}`);
  }
}

export async function findInstitution(
  partnerId: string,
): Promise<ParceiroInsert> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/institution/${partnerId}`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao consultar a instituição:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao consultar a instituição"
    );
  }
}
